import React from 'react';

const Banner = () => {
  return (
    <section className="liveclasses-banner-container">
      <div className="liveclasses-banner-content">
        <p className="liveclasses-banner-heading-text">
          Presenting our online live classes
        </p>
        <span className="liveclasses-banner-description-text">
          Project based online mentorship program where we actually make you
          think
        </span>
      </div>
    </section>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/Pages/LiveClasses/Banner.js